import { Box, Button, makeStyles, Popover, Theme, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import dayjs from "dayjs";
import { FC, useEffect, useMemo, useState } from "react";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const useStyles = makeStyles({
  calenderStyle: {
    display: "inherit",
    "& .rdrMonthsVertical": {
      flexDirection: "row",
    },
  },
});

const SelectRange: FC<SelectRangeProps> = ({ selectedDayDate, getRange }) => {
  const theme = useTheme();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRange, setSelectedRange] = useState<any>();

  const memoizedMinDate = useMemo(() => dayjs().startOf("day").toDate(), []);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "dateRangePicker" : undefined;
  const isSm = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  const handleSelect = (item: any) => {
    const start = item.selection.startDate;
    let end = item.selection.endDate;
    // todo - later, replace `2` with maximum months from predefined settings
    const twoMonthsLater = dayjs(start).add(2, "month");
    if (dayjs(end).isAfter(twoMonthsLater)) end = twoMonthsLater.toDate();
    setSelectedRange([
      {
        ...item.selection,
        endDate: end,
      },
    ]);
  };

  useEffect(() => {
    setSelectedRange([
      {
        startDate: selectedDayDate || memoizedMinDate,
        endDate: selectedDayDate || dayjs(memoizedMinDate).add(6, "day").toDate(),
        key: "selection",
      },
    ]);
  }, [selectedDayDate, memoizedMinDate]);

  useEffect(() => {
    if (selectedRange) {
      const start = selectedRange[0].startDate;
      let end = selectedRange[0].endDate;
      getRange({
        startDate: start,
        endDate: end,
      });
    }
  }, [selectedRange]);

  return (
    <>
      <Box display={isSm ? "" : "flex"} alignItems="flex-end">
        <Button
          aria-describedby={id}
          variant="outlined"
          onClick={handleClick}
          color="primary"
          style={{ textTransform: "lowercase" }}
        >
          {selectedRange
            ? `${dayjs(selectedRange[0].startDate).format("MMM DD, YYYY")} to ${dayjs(selectedRange[0].endDate).format(
                "MMM DD, YYYY"
              )}`
            : "Select Range"}
        </Button>
        <Box mx={isSm ? 0 : 2}>
          <Typography variant="caption" color="textSecondary">
            Maximum 2 months
          </Typography>
        </Box>
      </Box>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <DateRange
          ranges={selectedRange}
          onChange={handleSelect}
          minDate={memoizedMinDate}
          // rangedCalendars={false}
          showDateDisplay={false}
          color={theme.palette.error.dark}
          rangeColors={[theme.palette.primary.main]}
          className={classes.calenderStyle}
        />
      </Popover>
    </>
  );
};

interface SelectRangeProps {
  selectedDayDate?: Date;
  getRange: (range: any) => void;
}

export default SelectRange;
